export default __webpack_public_path__ + "static/media/North America.000ea92a.svg";